"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateVenueBreadcrumbRequestDto = exports.CreateVenueBreadcrumbRequestDto = exports.MAX_VENUE_BREADCRUMB_LENGTH = void 0;
const swagger_1 = require("@nestjs/swagger");
exports.MAX_VENUE_BREADCRUMB_LENGTH = 280;
class CreateVenueBreadcrumbRequestDto {}
exports.CreateVenueBreadcrumbRequestDto = CreateVenueBreadcrumbRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: exports.MAX_VENUE_BREADCRUMB_LENGTH
}), __metadata("design:type", String)], CreateVenueBreadcrumbRequestDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: '"Keep it on my profile" (true, never expires) or "Temporary" (false, 30 days). Omitted = kept, which is how notes from older app versions behave.'
}), __metadata("design:type", Boolean)], CreateVenueBreadcrumbRequestDto.prototype, "keepOnProfile", void 0);
class UpdateVenueBreadcrumbRequestDto {}
exports.UpdateVenueBreadcrumbRequestDto = UpdateVenueBreadcrumbRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: exports.MAX_VENUE_BREADCRUMB_LENGTH
}), __metadata("design:type", String)], UpdateVenueBreadcrumbRequestDto.prototype, "content", void 0);
//# sourceMappingURL=VenueBreadcrumbRequest.dto.js.map